import Vue from 'vue'
import Resource from 'vue-resource'
import store from '@/store'
Vue.use(Resource)

export default {
	getData () {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/monitors', {}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	},
	getQuotas () {
		return new Promise(function (resolve, reject) {
			Vue.http.get(store.state.apiURL + '/v1/monitor/quotas', {}).then(function (response) {
				resolve(response.body)
			}, function (response) {
				reject(response)
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/api/modules/monitor/monitor.js